export class TimeZone {
    id: number;
    description: string;
    abbreviation: string;
    intlName: string;

    private constructor(
        id: number,
        description: string,
        abbreviation: string,
        intlName: string
    ) {
        this.id = id;
        this.description = description;
        this.abbreviation = abbreviation;
        this.intlName = intlName;
    }

    public static Eastern = new TimeZone(
        10,
        "Eastern (ET)",
        "ET",
        "America/New_York"
    );
    public static Central = new TimeZone(
        20,
        "Central (CT)",
        "CT",
        "America/Chicago"
    );
    public static Mountain = new TimeZone(
        30,
        "Mountain (MT)",
        "MT",
        "America/Denver"
    );
    public static Pacific = new TimeZone(
        40,
        "Pacific (PT)",
        "PT",
        "America/Los_Angeles"
    );
    public static Alaska = new TimeZone(
        50,
        "Alaska (AKT)",
        "AKT",
        "America/Anchorage"
    );
    public static Hawaii = new TimeZone(
        60,
        "Hawaii (HT)",
        "HT",
        "Pacific/Honolulu"
    );

    public static asArray = () => [
        TimeZone.Eastern,
        TimeZone.Central,
        TimeZone.Mountain,
        TimeZone.Pacific,
        TimeZone.Alaska,
        TimeZone.Hawaii,
    ];

    public static fromId = (id: number): TimeZone =>
        TimeZone.asArray().find(tz => tz.id === id);

    /*
    determining browser timezone using the ECMAScript Internationalization API
    which has almost universal browser implementation.  It uses timezone names
    from the IANA timezone database. (e.g. "America/Chicago")

    There are a lot of names, including 9 for Indiana and 1 for Arizona.  We
    are only using the standard 6 in this enum.  Therefore some will return NONE.
    In the case that NONE or a timezone that isn't in our current enum is returned,
    we default the timezone to CENTRAL.

    https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/resolvedOptions
    https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
    https://stackoverflow.com/a/34602679/117428
    */

    public static currentTimezone = () => {
        const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const timezone = TimeZone.asArray().find(
            tz => tz.intlName === timezoneName
        );
        return timezone || TimeZone.Central;
    };
}
